/* eslint-disable react/require-default-props */
import React, { useRef, useContext } from 'react';
import PropTypes from 'prop-types';
import useStyles from '@front10/helpers/dist/UseStyles';
import { Context } from '@front10/helpers/dist/Context';
import ErrorBoundary from '../../utils/ErrorBoundary';
import { useIsMobileView } from '@front10/utils';

import Box from '../../elements/Box';
import FareItemDepartureInfo from '../_commons/atoms/FareItemDepartureInfo';
import FareItemReturnInfo from '../_commons/atoms/FareItemReturnInfo';
import FareItemOriginDestination from '../_commons/atoms/FareItemOriginDestination';
import FareItemJourneyType from '../_commons/atoms/FareItemJourneyType';
import FareItemRoute from '../_commons/atoms/FareItemRoute';
import FareItemLastSeen from '../_commons/atoms/FareItemLastSeen';
import FareItemTripDuration from '../_commons/atoms/FareItemTripDuration';
import Separator from '../_commons/atoms/Separator';
import FareItemMediumSize from '../FareItemMediumSize';
import defaultProps from './defaultProps';

const FareItemTravelClasses = (props) => {
  const {
    isMobile = false,
    usedErrorBoundary,
    showDepartureInfo,
    showReturnInfo,
    showJourneyType,
    showLastSeen,
    showRoute,
    showCallToAction,
    showDurationTrip,
    separatorDatesProps,
    fareItemDepartureInfo,
    fareItemReturnInfo,
    fareContentItem,
    fareItemJourneyType,
    fareItemOriginDestination,
    fareItemRoute,
    fareItemTripDuration,
    fareBodyItem,
    fareTravelClassesContainer,
    fareItemLastSeen,
    fareItemDepartureReturn,
    fareItemTravelClassCard,
    data,
    focusReferences,
    focusable,
    focusClass,
    fareItem,
    availableAtomsBody,
    ariaHidden = false
  } = props;

  const { direction, theme } = useContext(Context);
  const [className, style] = useStyles(props, { direction, theme });

  //TODO: Remove this rules
  // eslint-disable-next-line
  const fareBodyItemRef = useRef(null);

  let mobileView = useIsMobileView();
  if (isMobile) {
    mobileView = true;
  }

  let elements = {};

  elements = {
    FareItemOriginDestination: (
      <FareItemOriginDestination
        key="od"
        {...fareItemOriginDestination}
        {...data}
        id={`fare-item-origin-destination-${data.index}`}
      />
    ),
    FareItemRoute: showRoute && (
      <FareItemRoute
        key="route"
        {...fareItemRoute}
        {...data}
        id={`fare-item-route-${data.index}`}
      />
    ),
    FareItemDepartureReturnInfo: (showDepartureInfo || showReturnInfo) && (
      <Box
        {...fareItemDepartureReturn}
        key="drinfo"
        id={`fare-item-departure-return-info-${data.index}`}
      >
        {/* FareItemDepartureInfo */}
        {showDepartureInfo && fareItemDepartureInfo && (
          <FareItemDepartureInfo {...fareItemDepartureInfo} {...data} />
        )}
        {/* Separator */}
        {showDepartureInfo &&
          showReturnInfo &&
          data.formattedDepartureDate &&
          data.formattedReturnDate && <Separator floatLeft {...separatorDatesProps} />}
        {/* FareItemReturnInfo */}
        {showReturnInfo && fareItemReturnInfo && (
          <FareItemReturnInfo {...fareItemReturnInfo} {...data} />
        )}
      </Box>
    ),
    FareItemJourneyType: showJourneyType && (
      <FareItemJourneyType
        key="journey"
        {...fareItemJourneyType}
        {...data}
        id={`fare-item-journey-type-${data.index}`}
      />
    ),
    FareItemTripDuration: showDurationTrip && fareItemTripDuration && (
      <FareItemTripDuration
        key="duration"
        {...fareItemTripDuration}
        {...data}
        id={`fare-item-trip-duration-${data.index}`}
      />
    ),
    FareItemLastSeen: showLastSeen && data && (
      <FareItemLastSeen
        key="seen"
        {...fareItemLastSeen}
        {...data}
        id={`fare-item-last-seen-${data.index}`}
      />
    )
  };

  const render = (
    <Box
      tabIndex={focusable ? 0 : -1}
      focusable={focusable}
      focusReferences={focusReferences}
      dataTestId="fareItem"
      focusClass={focusClass}
      ariaHasPopUp={showCallToAction ? null : 'dialog'}
      ariaHidden={ariaHidden}
      {...fareItem}
      className={`fare-item-${mobileView ? 'columns' : 'rows'} ${className}`}
      style={style}
      id={`fare-item-multiple-travel-classes-${data.index}`}
    >
      <Box display="flex" rtlReverse>
        {/* fareContentItem */}
        <Box flex={fareContentItem.grow}>
          <Box
            display="flex"
            height="100"
            flexDirection={mobileView ? 'column' : 'row'}
            {...fareContentItem}
          >
            <Box
              className="fare-body-item"
              display="flex"
              focusReferences={fareBodyItemRef}
              rtlReverse
              height="100"
              width="100"
              flexDirection="column"
              {...fareBodyItem}
            >
              {availableAtomsBody.map((e) => elements[e])}
            </Box>
            <Box
              display="flex"
              flexDirection={mobileView ? 'column' : 'row'}
              {...fareTravelClassesContainer}
            >
              {data.travelClasses.map((fare, index) => {
                const opacity = fareItemTravelClassCard.travelClassOpacity[index] || '0.5';
                const color = fareItemTravelClassCard.fareItemTravelClass.bg || 'primary';

                const newFareItemTravelClassCard = {
                  ...fareItemTravelClassCard,
                  fareItemTravelClass: {
                    ...fareItemTravelClassCard.fareItemTravelClass,
                    'cmp-styles': {
                      ...fareItemTravelClassCard.fareItemTravelClass['cmp-styles'],
                      'background-color': `rgba(var(--${color}-rgb), ${opacity}) !important`
                    }
                  }
                };

                const fullFareData = {
                  ...fare,
                  origin: data.origin,
                  originCity: data.originCity,
                  destination: data.destination,
                  destinationCity: data.destinationCity,
                  departureDate: data.departureDate,
                  returnDate: data.returnDate,
                  searchDate: data.searchDate,
                  formattedDepartureDate: data.formattedDepartureDate,
                  formattedReturnDate: data.formattedReturnDate,
                  journeyType: data.journeyType
                };

                return (
                  <FareItemMediumSize
                    {...props}
                    {...newFareItemTravelClassCard}
                    data={fullFareData}
                    experimentalRenderAtoms={true}
                    showJourneyTypeTravelClassSeparator={false}
                    onlyFareFooterItem={false}
                  />
                );
              })}
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );

  return usedErrorBoundary ? <ErrorBoundary>{render}</ErrorBoundary> : render;
};

FareItemTravelClasses.propTypes = {
  /**
   * OnClick event
   */
  onClick: PropTypes.func,
  /**
   * OnClick event
   */
  onFocus: PropTypes.func,
  /**
   * Props of fareItem
   */
  fareItem: PropTypes.objectOf(PropTypes.any),
  /**
   * Props of fareItemDepartureInfo
   */
  fareItemDepartureInfo: PropTypes.objectOf(PropTypes.any),
  /**
   * Props of fareItemTripDuration
   */
  fareItemTripDuration: PropTypes.objectOf(PropTypes.any),
  /**
   * Props of fareItemReturnInfo
   */
  fareItemReturnInfo: PropTypes.objectOf(PropTypes.any),
  /**
   * Props of fareItemDeparture and fareItemReturn together
   */
  fareItemDepartureReturn: PropTypes.objectOf(PropTypes.any),
  /**
   * Props of fareItemJourneyType
   */
  fareItemJourneyType: PropTypes.objectOf(PropTypes.any),
  /**
   * Props of fareItemOriginDestinationImage
   */
  fareItemOriginDestinationImage: PropTypes.objectOf(PropTypes.any),
  /**
   * Props of fareItemOriginDestination
   */
  fareItemOriginDestination: PropTypes.objectOf(PropTypes.any),
  /**
   * Props of fareItemSale
   */
  fareItemSale: PropTypes.objectOf(PropTypes.any),
  /**
   * Props of fareItemRoute
   */
  fareItemRoute: PropTypes.objectOf(PropTypes.any),
  /**
   * Props of tileBodyItem
   */
  fareBodyItem: PropTypes.objectOf(PropTypes.any),
  /**
   * Props of tileContentItem
   */
  fareContentItem: PropTypes.objectOf(PropTypes.any),
  /**
   * Props of fareItemAirline
   */
  fareItemAirline: PropTypes.objectOf(PropTypes.any),
  /**
   * Props of fareItemDisclaimer
   */
  fareItemDisclaimer: PropTypes.objectOf(PropTypes.any),
  /**
   * Props of fareItemLastSeen
   */
  fareItemLastSeen: PropTypes.objectOf(PropTypes.any),
  /**
   * Props of separator
   */
  separatorDatesProps: PropTypes.objectOf(PropTypes.any),
  /**
   * Props of separator
   */
  separatorJourneyTypeProps: PropTypes.objectOf(PropTypes.any),
  /**
   * Turn off or on the journeyType section
   */
  showOriginDestinationImage: PropTypes.bool,
  /**
   * Turn off or on the journeyType section
   */
  showJourneyType: PropTypes.bool,
  /**
   * Turn off or on the showDurationTrip section
   */
  showDurationTrip: PropTypes.bool,
  /**
   * Turn off or on the travelClass section
   */
  showTravelClass: PropTypes.bool,
  /**
   * Turn off or on the DepartureInfo section
   */
  showDepartureInfo: PropTypes.bool,
  /**
   * Turn off or on the ReturnInfo section
   */
  showReturnInfo: PropTypes.bool,
  /**
   * Turn off or on the LastSeen section
   */
  showLastSeen: PropTypes.bool,
  /**
   * Turn off or on the Route section
   */
  showRoute: PropTypes.bool,
  /**
   * Turn off or on the Price section
   */
  showPrice: PropTypes.bool,
  /**
   * Turn off or on the Miles section
   */
  showMiles: PropTypes.bool,
  /**
   * Turn off or on the Fare Disclaimer section
   */
  showFareDisclaimer: PropTypes.bool,
  /**
   * Turn off or on the Airline section
   */
  showAirline: PropTypes.bool,
  /**
   * Show sale atom
   */
  showSale: PropTypes.bool,
  /**
   * Show FareItemRoute before FareItemDepartureInfo
   */
  showFareItemRouteBeforeDepartureInfo: PropTypes.bool,
  /**
   * Show FareItemLastSeen before FareItemPrice
   */
  showLastSeenBeforePrice: PropTypes.bool,
  /**
   * Raw data passed to the object
   */
  data: PropTypes.objectOf(PropTypes.any),
  /**
   * ref
   */
  focusReferences: PropTypes.func,
  /**
   * Turn off or on tabIndex in FareItem
   */
  focusable: PropTypes.bool,
  /**
   * Possible interactions will be Popup or Direct Deeplink
   */
  interactionHotZone: PropTypes.oneOf(['smart', 'whole', 'button']),
  /**
   * Determine if the component is protected using ErrorBoundary.
   * By default all components protect themselves
   */
  usedErrorBoundary: PropTypes.bool,
  /**
   * Data test ID of FareItem
   */
  dataTestId: PropTypes.string,
  /**
   * Define class to focus
   */
  focusClass: PropTypes.string,
  /**
   * Use this feature only at your own risk
   */
  availableAtomsBody: PropTypes.arrayOf(
    PropTypes.oneOf([
      'FareItemAirline',
      'FareItemDepartureReturnInfo',
      'FareItemJourneyType',
      'FareItemLastSeen',
      'FareItemOriginDestination',
      'FareItemRoute',
      'FareItemSale',
      'FareItemTripDuration',
      'FareItemDisclaimer',
      'FareItemCheckRestriction'
    ])
  )
};

FareItemTravelClasses.defaultProps = defaultProps;

FareItemTravelClasses.componentName = 'FareItemTravelClasses';

export default FareItemTravelClasses;
